import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import routes from "./routes";
import vuex from "./store/index";
import store from "./store";
import auxVars from "./aux-vars";
import MdIcon from "./components/helpers/MdIcon.vue";
import axios from "axios";
import numeral from "numeral";
import VueTippy, { TippyComponent } from "vue-tippy";
import "./assets/css/custom_user_style.css";


Vue.config.productionTip = false;
Vue.component("md-icon", MdIcon);
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

Vue.prototype.$hasPermission = permission => {
	return (
		store.state.currentUser?.permissions[permission.split(".").join("_")] ||
		false
	);
};
Vue.prototype.$hasModule = module => {
	try {
		return store.state.currentUser?.module[module] || false;
	} catch (error) {
		store.clearUser();
		window.location.href = "/login";
		return;
	}
};

Vue.prototype.$hasModuleGroup = modules => {
	try {
		return modules.find(module => store.state.currentUser?.module[module]);
	} catch (error) {
		store.clearUser();
		window.location.href = "/login";
		return;
	}
};

const NotFound = { template: "<p>Page not found</p>" };
const authPaths = ["/login", "/reset-passwd", "/update-passwd"];
const app = new Vue({
	el: "#app",
	store: vuex,
	render(h) {
		return h(this.ViewComponent);
	},
	data: {
		auxVars,
		store,
		warningProps: {
			message: "",
			loading: false,
			okAction: () => {},
			cancelAction: () => {}
		},
		alertProps: {
			message: "",
			variant: "success"
		}
	},
	computed: {
		ViewComponent() {
			return routes[this.store.state.currentRoute] || NotFound;
		},
		currentRouter() {
			return this.store.state.currentRoute;
		},
		api() {
			const self = this;
			let instance = axios.create({
				baseURL: process.env.VUE_APP_API_URL,
				// timeout: 1000,
				headers: {}
			});
			instance.interceptors.response.use(
				response => {
					return response;
				},
				error => {
					if (error?.response?.status === 406) {
						self.showAlert(error.response.data.error, {
							title: "Error de permisos",
							variant: "danger"
						});
					}
					return Promise.reject(error);
				}
			);
			if (this.store.state.currentToken) {
				instance.defaults.headers.authorization =
					"Bearer " + this.store.state.currentToken;
			}
			return instance;
		}
	},
	mounted() {
		if (
			this.store.state.currentToken === false &&
			!authPaths.includes(this.store.state.currentRoute)
		) {
			window.location.href = "/login";
		} else {
			this.api.post("/auth/me").then(res2 => {this.$root.store.setUserData(res2.data) });
		}
	},
	watch: {},
	methods: {
		showWarning({ message, okAction, cancelAction }) {
			let onOk = okAction || function() {};
			let onCancel = cancelAction || function() {};
			let text = message || "";
			let modalProps = {
				loading: false,
				message: "",
				okAction: () => {},
				cancelAction: () => {},
				setLoading: val => {
					this.warningProps.loading = val;
				}
			};
			this.warningProps = {
				...modalProps,
				...{ message: text, okAction: onOk, cancelAction: onCancel }
			};
			this.$emit("bv::show::modal", "warning-alert", null);
		},
		showAlert(title, props) {
			let toastTitle = title || "";
			let defaultProps = {
				variant: "success",
				solid: true,
				noCloseButton: true,
				autoHideDelay: 1500
			};
			this.$bvToast.toast(toastTitle, { ...defaultProps, ...props });
		},
		handleRequestError(error) {
			if (error.response) {
				// Request made and server responded
				// Solicitud realizada y servidor respondido
				console.log("HTTP ERROR: RESPONSE");
				//verificamos que el token no haya caducado
				if (error.response.status == 401) {
					this.store.clearUser();
					window.location.href = "/login";
					return;
				}
				//si el error es por otra causar
				//recuperamos el error y su codigo
				let message = "Error " + error.response.status+": ";
				//verificamos si el data es un objeto de errores
				if(typeof error.response.data === 'object' && Object.keys(error.response.data).length<3){
					//recuperamos los errores del objeto
					Object.entries(error.response.data).forEach(([key, value])=> {
						console.log(key + ": " + value);
						message += value+"\n";
					});
				}else{
					// Obtenemos el error por defecto
					message = error.message;
				}
				this.showAlert(message, { variant: "danger" });

			} else if (error.request) {
				console.log("HTTP ERROR: REQUEST");
				// The request was made but no response was received
				// Se realizó la solicitud pero no se recibió respuesta
				this.showAlert(error.request.toString(), { variant: "danger" });
			} else {
				console.log("HTTP ERROR: CATCH CLIENT");
				// Something happened in setting up the request that triggered an Error
				// Algo sucedió al configurar la solicitud que provocó un error
				this.showAlert(error.message, { variant: "danger" });
			}
		},
		setRouteEvt(evt) {
			evt.preventDefault();
			if (evt.target.pathname) this.store.setRoute(evt.target.pathname);
		},
		getParams() {
			const url = window.location.href;
			let params = {};
			let parser = document.createElement("a");
			parser.href = url;
			let query = parser.search.substring(1);
			let vars = query.split("&");
			for (let i = 0; i < vars.length; i++) {
				let pair = vars[i].split("=");
				params[pair[0]] = decodeURIComponent(pair[1]);
			}
			return params;
		},

		downloadPdf(res, fileName) {
			let fileURL = window.URL.createObjectURL(new Blob([res.data]));
			let fileLink = document.createElement("a");
			fileLink.href = fileURL;
			fileLink.setAttribute("download", fileName + ".pdf");
			document.body.appendChild(fileLink);
			fileLink.click();
			window.URL.revokeObjectURL(fileURL);
		},
		downloadExcel(res, fileName) {
			let fileURL = window.URL.createObjectURL(new Blob([res.data]));
			let fileLink = document.createElement("a");
			fileLink.href = fileURL;
			fileLink.setAttribute("download", fileName + ".xlsx");
			document.body.appendChild(fileLink);
			fileLink.click();
			window.URL.revokeObjectURL(fileURL);
		},
		downloadCsv(res, fileName) {
			let fileURL = window.URL.createObjectURL(new Blob([res.data]));
			let fileLink = document.createElement("a");
			fileLink.href = fileURL;
			fileLink.setAttribute("download", fileName + ".csv");
			document.body.appendChild(fileLink);
			fileLink.click();
			window.URL.revokeObjectURL(fileURL);
		},
		formatLblPrice(price, currency) {
			let priceF = numeral(price).format("0,0.[00]");
			return "$" + priceF + " " + currency.toUpperCase();
		},
		getItemFromAuxVarOpts(auxVarName, key) {
			let item = { value: key, text: key, class: "" };
			try {
				item = this.auxVars[auxVarName].find(item => item.value == key);
				if (item === undefined) {
					throw new Error("status not valid");
				}
			} catch (ex) {
				item = { value: key, text: key, class: "" };
				console.log(ex);
			}
			return item;
		},
		isEmpty(parametro) {
			if (parametro === undefined || parametro === null) {
				return true; // si es undefined o null, entonces es vacío
			}

			if (typeof parametro === 'string' && parametro.trim() === '') {
				return true; // si es una cadena vacía o solo espacios en blanco, entonces es vacío
			}

			if (Array.isArray(parametro) && parametro.length === 0) {
				return true; // si es un arreglo vacío, entonces es vacío
			}

			if (typeof parametro === 'object' && Object.keys(parametro).length === 0) {
				return true; // si es un objeto vacío, entonces es vacío
			}

			return false; // si no se cumple ninguna de las condiciones anteriores, entonces no es vacío
		},
		copyToClipboard(text) {
			navigator.clipboard.writeText(text)
		}
	}
});

window.addEventListener("popstate", () => {
	app.store.state.currentRoute = window.location.pathname;
});
